export default class DepartmentManagementColumnModel {
	static DepartmentManagementColumn = [
	  {
		  title: 'Department name',
		  align: 'left',
		  field: 'deptName'
	  }
	]
}
